export function getElementName({ WebComponent }) {
    return WebComponent.replace(/-[^-]+$/, '');
}
//# sourceMappingURL=get-element-name.js.map